enum SmartPoints {
  GET_TEST_RESULTS = 'intalent/results/get',
  GET_REC_PROGRAMS = 'intalent/recommendations/unique/get',
  GET_PROFESSIONS = 'api/get/recommends',
  GET_MATERIALS = 'api/get/newrecommends',
  INTALENT_URL = 'https://intalant.ru/',
  CREATE_TEST_RESULTS = '/api/intalent/results/create',
}

const ERROR_MESSAGE =
  'Ошибка загрузки данных, пожалуйста, повторите попытку позже!';

export { SmartPoints, ERROR_MESSAGE };



// WEBPACK FOOTER //
// ./src/services/smart/const.ts